import { gql } from '@apollo/client';

const GET_ECG_DATA_MAP_QUERY = gql`
  query getEcgDataMap($filter: EcgDataMapFilterInput!) {
    getEcgDataMap(filter: $filter) {
      isSuccess
      message
      ecgDataMap {
        samplingFrequency
        gain
        channels
        data {
          start
          stop
          sampleSize
          dataUrl
          hrUrl
        }
        querySignature
      }
    }
  }
`;

export default GET_ECG_DATA_MAP_QUERY;
